/* eslint-disable import/first */
import React, { useEffect, useState } from 'react';
import css from './index.module.scss';
import loading from './LOADER_v13.gif';

const Loader = ({ shadow = true, notToClear = false }) => {
  const [showLoader, setShowLoader] = useState(shadow);
  useEffect(() => {
    if (showLoader && !notToClear) {
      const timeout = setTimeout(() => {
        setShowLoader(false);
      }, 1800);

      return () => {
        clearTimeout(timeout);
      };
    }
  }, [notToClear, shadow, showLoader]);

  if (!showLoader) {
    return null;
  }

  return (
    <div className={shadow ? css.root : css.noShadow}>
      <img src={loading} width="400" alt="" />
    </div>
  );
};

export default Loader;
